export default __webpack_public_path__ + "static/media/sanitarna-oprema.13e4f6ef.jpeg";